import { useT, useRaw } from '@/lib/i18n';

const META = [
  { color: '#10B981', initials: 'AF', gradient: 'linear-gradient(135deg, #10B981, #34D399)' },
  { color: '#0EA5E9', initials: 'CV', gradient: 'linear-gradient(135deg, #0EA5E9, #38BDF8)' },
  { color: '#8B5CF6', initials: 'MS', gradient: 'linear-gradient(135deg, #8B5CF6, #C4B5FD)' },
];

export const Testimonials = () => {
  const t = useT();
  const raw = useRaw();
  const quotes = raw('home.testimonials.quotes') || [];
  return (
    <section
      data-testid="section-testimonials"
      className="relative py-20 md:py-28"
    >
      <div className="om-container">
        <div className="max-w-2xl">
          <span className="om-eyebrow">{t('home.testimonials.eyebrow')}</span>
          <h2
            className="om-h1 mt-5 text-[36px] sm:text-[46px] lg:text-[56px] text-[var(--om-ink)]"
            data-testid="testimonials-title"
          >
            {t('home.testimonials.title_l1')}<br />{t('home.testimonials.title_l2')}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {quotes.map((q, i) => {
            const m = META[i % META.length];
            return (
              <figure
                key={i}
                data-testid={`testimonial-${i + 1}`}
                className="relative flex flex-col rounded-3xl border border-[var(--om-border)] bg-white p-8 shadow-[0_10px_30px_-20px_rgba(10,14,26,0.15)]"
              >
                <svg
                  aria-hidden
                  width="28"
                  height="24"
                  viewBox="0 0 28 24"
                  className="opacity-25"
                  style={{ color: m.color }}
                >
                  <path
                    fill="currentColor"
                    d="M0 24V13.6C0 6.4 4.933 1.867 12 0v6.267c-3.6.933-5.4 3-5.4 6.2H12V24H0Zm16 0V13.6C16 6.4 20.933 1.867 28 0v6.267c-3.6.933-5.4 3-5.4 6.2H28V24H16Z"
                  />
                </svg>

                <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-[var(--om-ink-soft)]">
                  « {q.quote} »
                </blockquote>

                <figcaption className="mt-6 flex items-center gap-3">
                  <div
                    aria-hidden
                    className="grid h-11 w-11 place-items-center rounded-full text-sm font-bold text-white shadow-[0_6px_16px_-8px_rgba(10,14,26,0.35)]"
                    style={{ background: m.gradient }}
                  >
                    {m.initials}
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-[var(--om-ink)]">{q.name}</div>
                    <div className="text-xs text-[var(--om-muted)]">{q.role}</div>
                  </div>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
};
